/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookClosedIcon64Regular = forwardRef('BookClosedIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M21.5 20a1.5 1.5 0 0 0 0 3h21a1.5 1.5 0 0 0 0-3h-21Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 55a3 3 0 1 1 0-6h31.5a4.5 4.5 0 0 0 4.5-4.5v-34A4.5 4.5 0 0 0 48.5 6h-29a8.5 8.5 0 0 0-8.5 8.5V52a6 6 0 0 0 6 6h34.5a1.5 1.5 0 0 0 0-3H17Zm2.5-46h29a1.5 1.5 0 0 1 1.5 1.5v34a1.5 1.5 0 0 1-1.5 1.5H17a5.972 5.972 0 0 0-3 .803V14.5A5.5 5.5 0 0 1 19.5 9Z" })));
});
